import React, { FC } from 'react';

import CheckboxListSkeleton from '../../../../Loading/MUI/CheckboxListSkeleton';

import EmptySearch from '../SearchNoResult/EmptySearch';

import { SearchData, SearchDataItem, SearchListType } from '../types';

import SearchListItem from './SearchListItem';
import * as Styled from './styled';

type ItemId = SearchDataItem['id'];

export type SearchListProps = {
  dataSelected: Set<ItemId>;
  isFilterActive?: boolean;
  isLoading: boolean;
  isSearching: boolean;
  itemsFiltered: SearchData;
  onChange?: (itemId: ItemId, state: boolean) => void;
  type: SearchListType;
};

/**
 * List of all selectable items for search list
 *
 * @param props                Props passed to the component
 * @param props.dataSelected   IDs of the items already selected
 * @param props.isFilterActive Whether to show only selected items
 * @param props.isLoading      Whether the data is being loaded
 * @param props.isSearching    Whether something was typed into search
 * @param props.itemsFiltered  Filtered items after search
 * @param props.onChange       When checkbox is toggled
 * @param props.type           Whether the list is for members/groups/labels
 * @returns                    The component itself
 */
const SearchList: FC<SearchListProps> = ({
  dataSelected,
  isFilterActive = false,
  isLoading,
  isSearching,
  itemsFiltered,
  onChange,
  type,
}) => {
  if (isLoading === true) {
    return (
      <Styled.Ul>
        <CheckboxListSkeleton />
      </Styled.Ul>
    );
  }

  if (itemsFiltered.length === 0) {
    return (
      <EmptySearch reason={isSearching ? 'searching' : 'empty'} type={type} />
    );
  }

  return (
    <Styled.Ul>
      {itemsFiltered.map(item => {
        const { id } = item;
        const isSelected = dataSelected.has(id);

        if (!isSelected && isFilterActive) {
          return null;
        }

        return (
          <li key={`${type}-${id}`}>
            <SearchListItem
              isSelected={isSelected}
              item={item}
              onChange={onChange}
            />
          </li>
        );
      })}
    </Styled.Ul>
  );
};

export default SearchList;
